import {
    Button,
    Label,
    Table, TableBody,
    TableCell,
    TableCellActions,
    TableCellLayout,
    TableHeader,
    TableHeaderCell,
    TableRow,
    makeStyles, shorthands
} from "@fluentui/react-components";
import { DeleteFilled, DeleteRegular, EditFilled, EditRegular, bundleIcon } from "@fluentui/react-icons";
import { collection, getDocs, query, where } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import Layout from "./components/Layout";
import { auth, db, trackException } from "./services/firebase";
//import ImageDialog from "./components/ImageDialog";
import debounce from 'lodash/debounce';
import CustomSearchInput from "./components/CustomSearchInput";
import DeleteEventDialog from "./components/DeleteEventDialog";
import AddCoachForm from "./components/Forms/AddCoachForm";
import CoachDataService from "./services/coachDataService";
import UserDataService from "./services/userDataService";
import { PlusSVG } from "./static/svgs";
import useBreakpoint from "./hooks/useBreakpoint";
import "./components/Forms/FormStyle.css";
import ExportCsvButtons from "./components/ExportCsvButtons";

const EditIcon = bundleIcon(EditFilled, EditRegular);
const DeleteIcon = bundleIcon(DeleteFilled, DeleteRegular);

const useStyles = makeStyles({
    root: {
        ...shorthands.overflow("hidden"),
        display: "flex",
        height: "480px",
        backgroundColor: "#fff"
    },

    content: {
        ...shorthands.flex(1),
        ...shorthands.padding("16px"),
        display: "block",
        ...shorthands.gridArea("main")
    },

    breakFlex: {
        flexBasis: "100%",
        textAlign: "left"
    }
});

const columns = [
    { columnKey: "firstName", label: "First Name", width:'20%' },
    { columnKey: "lastName", label: "Last Name", width:'20%' },
    { columnKey: "coachType", label: "Coach Type", width:'20%' },
    { columnKey: "bio", label: "Bio", width:'40%' },
];

function CoachMember() {
    const styles = useStyles();
    const [user, loading, error] = useAuthState(auth);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [selectedCoach, setSelectedCoach] = useState();
    const [allusers, setAllUsers] = useState([]);
    const [coachMembers, setCoachMembers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredCoachMembers, setFilteredCoachMembers] = useState([]);
    const breakFlexpoint = useBreakpoint();
    const isMobile = breakFlexpoint === 'mobile';
    const [open, setOpen] = React.useState(false);
    const [currentuserId, setCurrentuserId] = React.useState('');
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = React.useState(false);
    const navigate = useNavigate();
    const openForm = (selectedItem) => {
        setIsFormOpen(true);
        setSelectedCoach(selectedItem);
    }

    const fetchUserNameAndCoach = async () => {
        try {
            if (!!user) {
                const userquery = query(collection(db, "Users"), where("email", "==", user?.email));
                const userdoc = await getDocs(userquery);
                const currentuser = userdoc.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
                setCurrentuserId(currentuser[0].id);
                const usersQuery = await UserDataService.getAllUser();
                setAllUsers(usersQuery.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

                const CoachsMemberQuery = await CoachDataService.getAllCoachMember();
                let coachsMemberArr = CoachsMemberQuery.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
                setCoachMembers(coachsMemberArr);
                setFilteredCoachMembers(coachsMemberArr)
            } else {
                console.log('no access');
            }
        } catch (err) {
            trackException(JSON.stringify(err))
            console.error(err);
            alert("An error occured while fetching user data");
        }
    };

    useEffect(() => {
        if (loading) return;
        if (!user) return navigate("/");
        fetchUserNameAndCoach();
    }, [user, loading]);

    const openDeleteForm = (selectedItem) => {
        setIsDeleteDialogOpen(true);
        setSelectedCoach(selectedItem);
        // fetchUserNameAndEvents();
    }

    const DeleteCoach = async () => {
        CoachDataService.deleteCoach(selectedCoach.id);
        setIsDeleteDialogOpen(false);
        fetchUserNameAndCoach();
    };

    // Debounce the handleSearch function
    const debouncedSearch = debounce(search => {
        const lowerSearch = search.toLowerCase();
        const filtered = coachMembers.filter(event =>{
            return(
                event.firstName.toLowerCase().includes(lowerSearch) ||
                event.lastName.toLowerCase().includes(lowerSearch)
            )
        });
        setFilteredCoachMembers(filtered);
    }, 300); // Adjust the debounce delay as needed

    const handleSearch = event => {
        const value = event.target.value;
        setSearchTerm(value);
        debouncedSearch(value);
    };
    const handleClear = () => {
        setSearchTerm('');
        debouncedSearch('');
    };

    const toExportRow = (item) => ({
      "First Name": item?.firstName ?? "",
      "Last Name": item?.lastName ?? "",
      "Coach Type": item?.coachType ?? "",
      "Bio": item?.bio ?? "",
    });

    return (
        <Layout>
            <div className={styles.content}>
                <div className={"d-flex justify-space-between top-content"}>
                    <div className={"d-flex"} style={{ gap: 8 }}>
                        <Button icon={<PlusSVG />} className={"primary-btn"} shape="circular" appearance="primary" onClick={() => openForm(undefined)}>{'Add Coach'.toUpperCase()}</Button>
                        <ExportCsvButtons
                            screenName="Coaches"
                            getFilteredRows={() => filteredCoachMembers}
                            getAllRows={() => coachMembers}
                            mapRow={toExportRow}
                        />
                    </div>
                    <CustomSearchInput
                        className={"custom-search-input"}
                        value={searchTerm}
                        onChange={handleSearch}
                        onClick={handleClear}
                    />
                </div>
                <div className={"table-layout"} style={{ border: isMobile ? "none" : undefined }} >
                    <Table aria-label="Table with cell actions">
                        <TableHeader className={"list-row"}>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableHeaderCell style={{ width: column.width }} key={column.columnKey}>
                                        <span className={"listHeaderText"}>{column.label}</span>
                                    </TableHeaderCell>
                                ))}
                            </TableRow>
                        </TableHeader>
                        <TableBody>
  {filteredCoachMembers.length > 0 && filteredCoachMembers.map((item) =>
    isMobile ? (
      <div key={item.id} className="coach-member-card">
        <div className="coach-member-card-header">
          <div className="coach-member-card-title">
            {item.firstName} {item.lastName}
          </div>
          <div className="coach-member-card-actions">
            <Button
              icon={<EditIcon />}
              className="edit-icon"
              appearance="subtle"
              aria-label="Edit"
              onClick={() => openForm(item)}
            />
            <Button
              icon={<DeleteIcon />}
              className="delete-icon"
              appearance="subtle"
              aria-label="Delete"
              onClick={() => openDeleteForm(item)}
            />
          </div>
        </div>
        <span className="separator"></span>
        <div className="coach-member-card-row">
          <span className="coach-member-card-label">Coach Type</span>
          <span className="coach-member-card-value">{item.coachType}</span>
        </div>
        <span className="separator"></span>
        <div className="coach-member-card-row">
          <span className="coach-member-card-label">Bio</span>
          <span className="coach-member-card-value">{item.bio?.substring(0, 150)}</span>
        </div>
      </div>
    ) : (
      <TableRow key={item.id}>
        <TableCell className={"table-row-fonts__primary"}>
          <TableCellLayout>
            {item.firstName}
          </TableCellLayout>
        </TableCell>
        <TableCell className={"table-row-fonts__desc"}>
          <TableCellLayout>
            {item.lastName}
          </TableCellLayout>
        </TableCell>
        <TableCell className={"table-row-fonts__desc"}>
          <TableCellLayout>
            {item.coachType}
          </TableCellLayout>
        </TableCell>
        <TableCell className={"table-row-fonts__desc"}>
          <TableCellLayout>
            <Label title={item.bio}>{item.bio?.substring(0, 150)}</Label>
          </TableCellLayout>
          <TableCellActions>
            <Button
              icon={<EditIcon />}
              appearance="subtle"
              aria-label="Edit"
              onClick={() => openForm(item)}
            />
            <Button
              icon={<DeleteIcon />}
              appearance="subtle"
              aria-label="Delete"
              onClick={() => openDeleteForm(item)}
            />
          </TableCellActions>
        </TableCell>
      </TableRow>
    )
  )}
</TableBody>
                    </Table>
                </div>
            </div>
            <AddCoachForm isOpen={isFormOpen} setIsOpen={(val) => setIsFormOpen(val)} selectedCoach={selectedCoach}
                updateGrid={fetchUserNameAndCoach} createdBy={currentuserId} users={allusers}></AddCoachForm>
            {/*<ImageDialog open={open} setOpen={setOpen} selectedEvent={selectedCoach}></ImageDialog> */}
            <DeleteEventDialog isDeleteDialogOpen={isDeleteDialogOpen}
                setIsDeleteDialogOpen={setIsDeleteDialogOpen} DeleteEvent={DeleteCoach} text={'Coach'} />

        </Layout>
    )
}

export default CoachMember;